import { useCallback, useEffect, useRef, useState } from 'react';
import { Typography, IconButton, Box, FormControlLabel, Checkbox, Tooltip, Card, CardContent, Tabs } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem'
import Menu from '@mui/material/Menu';
import { Scrollbars } from 'rc-scrollbars';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { CardsWithFilter } from './cardformatters';
import Barcode from 'react-barcode';
// import PreviewIcon from '@mui/icons-material/Preview';
import showStatusImg from '../../images/others/showStatus.png'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddIcon from '@mui/icons-material/Add';
import { ShowModal } from 'components/Modal';
import { useReactToPrint } from 'react-to-print';
import PrintIcon from '@mui/icons-material/Print';
import { colors } from '../../styles/colors';
import { useSelector } from 'react-redux';
import { loginSelector } from 'store/slices/loginSlice';
import { StyledTab } from 'utils/formatters';
import { hoverStyle } from "styles/main";
import { CancelButton, OKButton } from 'components/EIComponents/LittleComponents';
import usePreventDoubleClick from 'components/AntiDBC';

/*Это файл содержащий форматеры столбцов, тут описанно их поведение и отображение
Drag and drop имеет следующую структуру

./src
    ./api
        ./apiBridges 
            ./dndBridge.js  (Бриджи для дескриптора)
        ./descriptors
            ./addressableStorage.js (Дескрипторы)
    ./components
        ./DragDrop.js (Основной элемент drag end drop)
    ./utils
        ./dndutils
            ./cardformatters.js (Форматеры тикетов)
            ./containerformatters.js  (Форматеры контейнеров)
            ./staticresorces.js (Статические ресурсы)
            ./toppanelformaters.js  (Форматеры панелей фильтров)

Для создания нового элемента он размещается в соответствующем файле, после чего вкладывается в дескриптор, который работает как конструктор для данного меню
*/

// Диалоговое окно для добавления столбца
export const AddTableDialog = ({parentStatus, setListTables, listTables, setEmitFlag}) => {
    
    // Переменная для имени нового столбца
    const [name, setName] = useState(null);
    const [show, setShow] = useState(false);
    // Флаг открытия диалогового окна
    const [open, setOpen] = useState(false);
    // Обработчик открытия окна
    const DialoghandleClickOpen = () => {
      setOpen(true);
    };
    
    // Обработчик закрытия окна
    const DialoghandleClose = () => {
      setName(null);
      setOpen(false);
    };
  
    // Обработчик добавления новой колонки в массив колонок
    const DialoghandleAdd = () => {
      if (name && (colors.color !== '#e0e0e0')){
        setEmitFlag(true);
        var array = [...listTables];
        var id = + array.reduce((prev, current) => (+prev.status > +current.status) ? prev : current).status + 1;
        var table = { name: name, status: `${id}`, color:colors.color, colorcircule:colors.colorcircule, showStatus: show};
  
        array.splice(array.findIndex(item=> item.status === parentStatus) + 1, 0, table);
        setListTables(array);
        DialoghandleClose();
      }
    };
  
    // Стандартный набор цветов для колонок
    const colorsmas = [
      {color:'#f9f28a', colorcircule:'#e8dd2f'},
      {color:'#8da5fd', colorcircule:'#8ea5fd'},
      {color:'#f97e83', colorcircule:'#f87d83'},
      {color:'#fcc9ff', colorcircule:'#f79afc'},
      {color:'#76d56c', colorcircule:'#53f178'},
      {color:'#83ffdf', colorcircule:'#7fecd1'},
      {color:'#fcba67', colorcircule:'#f2ba72'},
    ];
    
    // Переменная для хранения цвета
    const [colors, setColors] = useState({color:'#e0e0e0', colorcircule:'#e0e0e0'});
  
    return(
      <div
        style={{verticalAlign:'top', display: 'inline-block'}}
      >
        <IconButton
          aria-haspopup="true"
          size='small'
          onClick={DialoghandleClickOpen}
        >
            <AddCircleOutlineIcon/>
        </IconButton>
  
        <Dialog
          open={open}
          onClose={DialoghandleClose}
          PaperProps={{ sx: { borderRadius: "40px" } }}
          >
            <div
              style={{height:'400px', width:'600px'}}
            >
              
              <div style = {{position: 'relative', paddingTop: '15px'}}>
                <div style = {{alignContent: 'center', alignItems: 'center'}}>
                    <div style={{ display: 'flex', flexDirection:'column', alignItems: 'center' }}>
                        <Typography variant="body1" sx={{fontWeight: '800', fontSize: '30px', display: 'row', marginTop:'20px'}}>Добавить новую воронку</Typography>
                        <TextField variant="filled" label="Название" onChange={(e) => {setName(e.target.value);}} sx={{position: 'relative', fontWeight: 'bold', backgroundColor:colors.color, marginTop:'30px', width:'70%', borderRadius:'10px', "& .MuiFilledInput-root":{backgroundColor: colors.color, borderRadius:'7px'}}} InputProps={{disableUnderline: true}}></TextField>
                        <div style={{display:'flex', width:'70%', height:'60px', justifyContent:'space-between'}}>
                          {colorsmas.map((el, index)=> (
                            <div key={index} onClick={() => setColors(el)} style={{width:'40px', height:'40px', background:el.color, marginTop:'20px', borderRadius:'10px', cursor:'pointer'}}>
                            </div>
                          )) }
                        </div>
                        <div style={{display:'flex', flexDirection:"row", alignItems: "center", marginTop: "15px"}}>
                          <Checkbox
                            checked={show}
                            onChange={(e) => {setShow(e.target.checked)}}
                            inputProps={{ 'aria-label': 'controlled' }}
                          />
                          <Typography variant="body1" >Отображать статус клиенту</Typography>
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop:'30px'}}>
                  <Button variant="contained" onClick={DialoghandleClose} sx={{textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor:'#078376'}} >Отмена</Button>
                  <Button variant="contained" onClick={DialoghandleAdd} sx={{textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor:'#078376'}}>Добавить</Button>
                </div>
              </div>
            </div>
        </Dialog>
      </div>
    )
  }
  
  // Диалоговое окно для изменения столбца. В принципе логика идентична, за исключением стартовых параметров колонки
  export const EditTableDialog = ({handleClose, currentStatus, setListTables, listTables, oldname, oldcolor, oldcolorcircule, setEmitFlag, showStatus = false}) => {
  
    const [name, setName] = useState(oldname);
    const [show, setShow] = useState(showStatus);
    const [open, setOpen] = useState(false);
    const DialoghandleClickOpen = () => {
      setOpen(true);
    };
  
    const DialoghandleClose = () => {
      setName(null);
      setOpen(false);
      handleClose();
    };
  
    const DialoghandleAdd = () => {
      if (name && (colors.color !== '#e0e0e0')){
        setEmitFlag(true);
        var array = [...listTables];
        var table = { name: name, status: currentStatus, color:colors.color, colorcircule:colors.colorcircule, showStatus: show};
  
        array[(array.findIndex(item=> item.status === currentStatus))] = table;
        setListTables(array);
        
        DialoghandleClose();
      }
    };
  
  
    const colorsmas = [
      {color:'#f9f28a', colorcircule:'#e8dd2f'},
      {color:'#8da5fd', colorcircule:'#8ea5fd'},
      {color:'#f97e83', colorcircule:'#f87d83'},
      {color:'#fcc9ff', colorcircule:'#f79afc'},
      {color:'#76d56c', colorcircule:'#53f178'},
      {color:'#83ffdf', colorcircule:'#7fecd1'},
      {color:'#fcba67', colorcircule:'#f2ba72'},
    ];
  
    const [colors, setColors] = useState({color: oldcolor, colorcircule: oldcolorcircule});
  
    return(
      <div>
        <MenuItem onClick={DialoghandleClickOpen}>Редактировать</MenuItem>
        <Dialog
          open={open}
          onClose={DialoghandleClose}
          PaperProps={{ sx: { borderRadius: "40px" } }}
          >
            <div
              style={{height:'400px', width:'600px'}}
            >
              
              <div style = {{position: 'relative', paddingTop: '15px'}}>
                <div style = {{alignContent: 'center', alignItems: 'center'}}>
                    <div style={{ display: 'flex', flexDirection:'column', alignItems: 'center' }}>
                        <Typography variant="body1" sx={{fontWeight: '800', 'font-size': '30px', display: 'row', marginTop:'20px'}}>Изменить воронку</Typography>
                        <TextField variant="filled" defaultValue={name} label="Название" onChange={(e) => {setName(e.target.value);}} sx={{position: 'relative', fontWeight: 'bold', backgroundColor:colors.color, marginTop:'30px', width:'70%', borderRadius:'10px', "& .MuiFilledInput-root":{backgroundColor: colors.color, borderRadius:'7px'}}} InputProps={{disableUnderline: true}}></TextField>
                        <div style={{display:'flex', width:'70%', height:'60px', justifyContent:'space-between'}}>
                          {colorsmas.map((el, index)=> (
                            <div key={index} onClick={() => setColors(el)} style={{width:'40px', height:'40px', background:el.color, marginTop:'20px', borderRadius:'10px', cursor:'pointer'}}>
                            </div>
                          )) }
                        </div>
                        <div style={{display:'flex', flexDirection:"row", alignItems: "center", marginTop: "15px"}}>
                          <Checkbox
                            checked={show}
                            onChange={(e) => {setShow(e.target.checked)}}
                            inputProps={{ 'aria-label': 'controlled' }}
                          />
                          <Typography variant="body1" >Отображать статус клиенту</Typography>
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop:'30px'}}>
                  <Button variant="contained" onClick={DialoghandleClose} sx={{textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor:'#078376'}} >Отмена</Button>
                  <Button variant="contained" onClick={DialoghandleAdd} sx={{textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor:'#078376'}}>Изменить</Button>
                </div>
              </div>
            </div>
        </Dialog>
      </div>
    )
  }
  
  // Выпадающее меню для взаимодействия со столбцом
  export const DropDowntableMenu = ({currentStatus, setListTables, listTables, name, color, colorcircule, listItems, setEmitFlag, showItems, showStatus}) => {
    
    // Переменная отвечающая за привязку к компоненту
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    
    // Обработчик привязки
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    
    // Обработчик пункта удаления столбца
    const removeTable = () => {
      if (!showItems[currentStatus]){
        setEmitFlag(true); // Выставление флага обновления данных
        setListTables([...listTables.filter(item => (item.status !== currentStatus))]) // Изменение массива столбцов
      }
      handleClose()
    }
    
    // Обработчик закрытия меню
    const handleClose = () => {
      setAnchorEl(null);
    };
    return (
      <div
      style={{display:'block',
        clear: 'both',
        float: 'right',
        height: '34px'}}
      >
        <IconButton
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
              size='small'
              sx={{
                
              }}
          >
              <MoreVertIcon/>
          </IconButton>
        
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          <EditTableDialog 
          handleClose={handleClose}
          currentStatus={currentStatus}
          setListTables={setListTables} 
          listTables={listTables}
          oldname={name}
          oldcolor={color}
          oldcolorcircule={colorcircule}
          setEmitFlag={setEmitFlag}
          showStatus={showStatus}
          />
          {listTables.length > 1 &&<MenuItem onClick={removeTable}>Удалить</MenuItem>}
        </Menu>
      </div>
    );
  }
  
  // Базовый контейнер для отображения тикетов
  export const ContainerCards = ({
    ds, 
    color, 
    colorcircule, 
    showItems, 
    items = [], 
    showStatus = false,
    status, 
    name, 
    filtername, 
    isDragging, 
    handleDragging, 
    handleUpdateList, 
    handleUpdateTicket, 
    toggleDrawer, 
    setInsertelement, 
    setListTables, 
    listTables, 
    setEmitFlag,  
    setListItems,
    dragItemRef,
    selectedColumnRef,
    cloneItemRef
  }) => {

    const { rules } = useSelector(loginSelector);
    const columnRef = useRef(null);

    const handleDrop = (e) => {
        e.preventDefault();
        handleUpdateList(e.dataTransfer.getData('text'), status);
        handleDragging(false);
        cloneItemRef.current.remove();
        dragItemRef.current.style.visibility = 'visible'; dragItemRef.current.style.height = ''; dragItemRef.current.style.margin = '10px'; dragItemRef.current.style.padding = ''; dragItemRef.current.style.overflow = '';
        dragItemRef.current.style.opacity = '1'; dragItemRef.current.style.boxShadow = '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)';
    }
    
    const handleDragHeaderOver = (e) => {
      if (isDragging){
        e.preventDefault()
        if (window.getComputedStyle(cloneItemRef.current).display === "none") cloneItemRef.current.style.display = '';
        dragItemRef.current.style.opacity = '1';
        selectedColumnRef.current?.querySelector(`.zeroTicket`).prepend(cloneItemRef.current);
      }
      setInsertelement({position:null, idanchor:-1})
    }
    
    const handleDragOver = (e) => { 
        e.preventDefault(); 
        if (selectedColumnRef.current?.id !== status) {selectedColumnRef.current = columnRef.current;}
    }

    return (
        <div
          key={name+status}
          style = {{
            minWidth: '400px', // Сохраняем исходную ширину
            marginRight:'-25px',
            height:'100%',
            position: 'relative',
            display: 'inline-block',
            verticalAlign:'top', 
            marginLeft: ds.admin && (rules.includes("main.change_columns") || rules.includes("admin"))? "0px": "20px"
          }}
        >
        <div
          style = {{
            width: '340px', // Сохраняем ширину внутренней части
            minWidth: '250px',
            position: 'relative',
            backgroundColor: 'rgba(255, 255, 255, 0.0)', //'rgba(255, 255, 255, 0.4)',
            borderRadius:'10px',
            display: 'inline-block',
            flexDirection: 'column',
            height: "100%"
            // height: 'auto',
            // maxHeight: "100%"

          }}
          id={status}
          ref={columnRef}
          className={`layout-cards ${isDragging ? 'layout-dragging' : ''} card_container${status}`}
          onDrop={handleDrop}
          onDragOver={handleDragOver}
        >
          <div
              onDragOver={handleDragHeaderOver}
              style = {{
                  width: '340px',
                  minWidth: '250px',
                  position: 'relative',
                  // Добавляем цветную линию сверху
                  borderTop: `8px solid ${color}`, 
                  borderTopRightRadius:  '10px',
                  borderTopLeftRadius: '10px',
                  // Динамическое скругление низа шапки как в ASContainerCards
                  borderBottomRightRadius: showItems?.[status]?.length === 0? '10px' : "0px",
                  borderBottomLeftRadius: showItems?.[status]?.length === 0? '10px' : "0px",
                  display: 'inline-block', 
                  verticalAlign:'top',
                  height: "65px",
                  backgroundColor: 'rgba(255, 255, 255, 0.4)'
              }}
              >
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', minHeight:'20px', marginTop:'10px', marginBottom:'10px'}}>
                <div style={{ 
                    display:'flex', 
                    margin: '0px auto', 
                    marginTop: "2px", 
                    alignItems: 'center', 
                    justifyContent: 'space-between'
                }}>
                  {showStatus && 
                    <img alt="" src={showStatusImg} width={14} height={14} style={{ marginRight: '-30px', zIndex: 1 }}></img>
                  }
                  
                  <Typography variant="subtitle2" noWrap sx={{
                    position: 'relative', 
                    marginLeft:'40px', 
                    maxWidth:'220px', 
                    fontSize: '16px',
                    fontWeight:'bold',
                    color: "#666666",
                    textTransform: 'uppercase',
                  }}>
                    {name}
                  </Typography>

                  <Typography sx = {{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minWidth: '1.6em',
                      height: '1.6em',
                      borderRadius: '50%',
                      backgroundColor: "#e9f3f3",
                      marginLeft:'10px',
                      fontSize: '16px',
                      fontWeight:'bold',
                      color: "#666666",

                  }}>
                      {showItems[status] ? Object.keys(showItems[status]).length : 0}
                  </Typography>
                </div>

                {ds.admin && !ds.nested && (rules.includes("main.change_columns") || rules.includes("admin")) ? 
                  <DropDowntableMenu
                    currentStatus={status}
                    setListTables={setListTables}
                    listTables={listTables}
                    name={name}
                    color={color}
                    colorcircule={colorcircule}
                    listItems={items}
                    setEmitFlag={setEmitFlag}
                    showItems={showItems}
                    showStatus={showStatus}
                  /> : 
                  <div style={{display:'block', clear: 'both', float: 'right', height: '34px', width: '34px'}} />
                }
              </div>
          </div>
          <div style={{height: 'calc(100% - 65px)'}}>
            <Scrollbars
              className='mainContainer'
              style={{height: "100%"}}
              autoHide
            >
              <div className = {`zeroTicket`}/>
              <CardsWithFilter
                  ds={ds.items[0]}
                  items={items}
                  filter={filtername}
                  isDragging={isDragging}
                  handleDragging={handleDragging}
                  toggleDrawer={toggleDrawer}
                  showItems={showItems[status]}
                  setInsertelement={setInsertelement}
                  setEmitFlag={setEmitFlag}
                  setListItems={setListItems}
                  handleUpdateTicket={handleUpdateTicket}
                  dragItemRef={dragItemRef}
                  selectedColumnRef={selectedColumnRef}
                  cloneItemRef={cloneItemRef}
              />
            </Scrollbars>
          </div>
        </div>
        {ds.admin && !ds.nested && (rules.includes("main.change_columns") || rules.includes("admin")) ?
          <AddTableDialog
            parentStatus={status}
            setListTables={setListTables}
            listTables={listTables}
            setEmitFlag={setEmitFlag}
          /> : <></>
        }
      </div>
    )
  }


  // Компонент для добавления вложенного столбца
  export const EditNestedTableDialog = ({
    handleClose, 
    currentStatus = null, 
    parentStatus = null, 
    setListTables, 
    listItems, 
    listTables, 
    oldname = 'Новая полка', 
    oldcolor = '#e0e0e0', 
    oldcolorcircule = '#e0e0e0', 
    setEmitFlag,
  }) => {
    const [name, setName] = useState(oldname ? oldname : null);

    let Tidx = listTables.findIndex((el) => el.status === currentStatus)    
    const [tables, setTables] = useState(listTables);
  
    const [open, setOpen] = useState(false);
    const DialoghandleClickOpen = () => {
      setOpen(true);
    };
  
    const DialoghandleClose = () => {
      setName(null);
      setOpen(false);
      handleClose();
    };

    const DialoghandleAdd = () => {
      
      if (name && colors){
        let tmp = JSON.parse(JSON.stringify(tables))
        tmp[Tidx].name = name
        tmp[Tidx].color = colors.color
        tmp[Tidx].colorcircule =colors.colorcircule
        tmp[Tidx].items.map((el) => {
          el.color = colors.color
          el.colorcircule =colors.colorcircule
        })
        setListTables(tmp);
        DialoghandleClose();
      }
    };
    
    const addNewTable = () => {
      let id = tables[Tidx].status
      let i = parseInt(tables[Tidx].items[tables[Tidx].items.length-1].name) +1
      let tmp = JSON.parse(JSON.stringify(tables))
      tmp[Tidx].items.push({name:i, status:`${id}_${i}`})
      setTables(tmp)
    }

    const delTable = (ind) => {
      let tmp = JSON.parse(JSON.stringify(tables))
      tmp[Tidx].items.splice(ind, 1)
      setTables(tmp)
    }
  
    const colorsmas = [
      {color:'#f9f28a', colorcircule:'#e8dd2f'},
      {color:'#8da5fd', colorcircule:'#8ea5fd'},
      {color:'#f97e83', colorcircule:'#f87d83'},
      {color:'#f68dfc', colorcircule:'#f79afc'},
      {color:'#76d56c', colorcircule:'#53f178'},
      {color:'#83ffdf', colorcircule:'#7fecd1'},
      {color:'#fcba67', colorcircule:'#f2ba72'},
    ];
  
    const [colors, setColors] = useState(oldcolor ? {color: oldcolor, colorcircule: oldcolorcircule} : {color:'#e0e0e0', colorcircule:'#e1e1e1'});

    console.log("LI", listItems)
    console.log("T", tables[Tidx].items.length)

    return(
      <div>
        {/* <MenuItem onClick={DialoghandleClickOpen}>Редактировать</MenuItem> */}
        <Dialog
          open={open}
          onClose={DialoghandleClose}
          PaperProps={{ sx: { borderRadius: "40px", overflowX: 'hidden' } }}
          >
            <div
              style={{height:'450px', width:'600px', overflowX: 'hidden'}}
            >
              <div style = {{position: 'relative', paddingTop: '15px'}}>
                <div style = {{alignContent: 'center', alignItems: 'center'}}>
                    <div style={{ display: 'flex', flexDirection:'column', alignItems: 'center' }}>
                        <Typography variant="body1" sx={{fontWeight: '800', 'font-size': '30px', display: 'row', marginTop:'20px'}}>Изменить воронку</Typography>
                        <TextField variant="filled" defaultValue={name} label="Название" onChange={(e) => {setName(e.target.value);}} 
                          sx={{position: 'relative', 
                            fontWeight: 'bold', 
                            backgroundColor:colors.color, 
                            marginTop:'30px', 
                            width:'70%', 
                            borderRadius:'10px', "& .MuiFilledInput-root":{backgroundColor: colors.color, borderRadius:'7px'}}} 
                          InputProps={{disableUnderline: true}}>
                        </TextField>
                        {/* <TextField variant="filled" defaultValue={count} label="Количество полок" onChange={(e) => {setCount(e.target.value);}} sx={{position: 'relative', fontWeight: 'bold', backgroundColor:'#e0e0e0', marginTop:'30px', width:'70%', borderRadius:'10px', "& .MuiFilledInput-root":{backgroundColor: '#e0e0e0', borderRadius:'7px'}}} InputProps={{disableUnderline: true}}></TextField> */}

                        <div style={{display: 'flex', flexDirection: "row", width:'70%', alignItems: "center"}}>
                          <Typography sx={{'font-size': '20px', marginRight: "10px"}}>Полки</Typography> 
                          <IconButton aria-label="menu" onClick={() => {addNewTable()}} disabled={tables[Tidx].items.length >=20}>
                              <AddIcon
                                  sx={{
                                      transition: 'all 0.3s ease',
                                      '&:hover': hoverStyle,
                                      height: "20px"
                                  }}
                              />
                          </IconButton>
                        </div>
                        <div style={{
                          display: 'grid',
                          gridTemplateColumns: 'repeat(3, 1fr)', // три равные колонки
                          rowGap: '10px',
                          columnGap: '20px',
                          width: '70%'
                        }}>
                        {
                          tables[Tidx].items.map((el, ind) => {
                            return (
                              <Card sx={{ borderRadius: 3, marginTop: "10px", marginRight: "10px", height: "35px"}}>
                                  <CardContent sx={{padding: "0px", paddingLeft: "10px", display: 'flex', flexDirection: "row", width:"110px", justifyContent:'space-between', alignItems: "center"}}>
                                    <Typography sx={{'font-size': '20px'}}>{el.status.replaceAll('_', '-')}</Typography>
                                    <IconButton 
                                      aria-label="delete" 
                                      onClick={() => {
                                        delTable(ind)
                                      }} 
                                      disabled = {listItems[tables[Tidx].items[ind].status] && Object.keys(listItems[tables[Tidx].items[ind].status]).length > 0}
                                    >
                                        <DeleteForeverIcon
                                            sx={{
                                                transition: 'all 0.3s ease',
                                                '&:hover': hoverStyle,
                                                height: "20px"
                                            }}
                                        />
                                    </IconButton>
                                  </CardContent>
                              </Card>
                            )
                          })
                        }
                        </div>

                        <div style={{display:'flex', width:'70%', height:'60px', justifyContent:'space-between'}}>
                          {colorsmas.map((el, index)=> (
                            <div key={index} onClick={() => setColors(el)} style={{width:'40px', height:'40px', background:el.color, marginTop:'20px', borderRadius:'10px', cursor:'pointer'}}>
                            </div>
                          )) }
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop:'30px'}}>
                  <Button variant="contained" onClick={DialoghandleClose} sx={{textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor:'#078376'}} >Отмена</Button>
                  <Button variant="contained" onClick={DialoghandleAdd} sx={{textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor:'#078376'}}>Изменить</Button>
                </div>
              </div>
            </div>
        </Dialog>
      </div>
    )
  }


  
  export const PrintBarcode = ({handleClose, listTables, currentStatus, currentTab}) => {
    console.log("currentStatus", currentStatus)
    console.log("listTables", listTables)
    // const [checked, setChecked] = useState([true, ...listTables[+currentStatus-1].items.map(el => {return true})]);

    const currentTable = listTables.find((el) => el.status === currentStatus) || undefined

    const [checked, setChecked] = useState([true, true, currentTable?.items.map(el => {return true}) || []]);

    const handleChangeParentCheck = (event) => {
      setChecked(checked.map(el => {return event.target.checked}));
    };

    const handleChangeCheck = (event, id) => {
      let buff_checked = [...checked];
      buff_checked[id] = event.target.checked;
      console.log("buff_checked", buff_checked)
      setChecked(buff_checked);
    };

    const [open, setOpen] = useState(false);
    const DialoghandleClickOpen = () => {
      setOpen(true);
    };
  
    const DialoghandleClose = () => {
      setOpen(false);
      handleClose();
    };

    // const DialoghandlePrint = () => {
    //   let mywindow = window.open('', 'PRINT', 'height=900,width=1200,top=100,left=150');

    //   mywindow.document.write(`<html><head><title>Печать</title>`);
    //   mywindow.document.write('</head><body >');
    //   checked.map((el, index) => {
    //     if (el)
    //       mywindow.document.write(document.getElementById(`BarcodeElement_${index}`).outerHTML)
    //     return true;
    //   })
    //   mywindow.document.write('</body></html>');
    
    //   mywindow.document.close();
    //   mywindow.focus();
    
    //   mywindow.print();
    //   mywindow.close();
    //   DialoghandleClose();
    //   return true;
    // };

    const name = currentTable?.name || "";

    const children = (
      <Box sx={{ display: 'flex', flexDirection: 'column', ml: 3 }}>
        <Scrollbars
          className='mainContainer'
          autoHeight autoHeightMax={280}
        >
        <FormControlLabel
          label={currentTab?.title}
          control={<Checkbox checked={checked[0]} onChange={(e) => handleChangeCheck(e, 0)} />}
        />
        <FormControlLabel
          label={name}
          control={<Checkbox checked={checked[1]} onChange={(e) => handleChangeCheck(e, 1)} />}
        />
        {currentTable.items.map((el,index) => {
          return (
            <div>
              <FormControlLabel
                label={Array.from(name)[0] + '-' + currentStatus + '-' + el.name}
                control={<Checkbox checked={checked[index+2]} onChange={(e) => handleChangeCheck(e, index+2)} />}
              />
            </div>
          )
        })}
        </Scrollbars>
      </Box>
    );

    const getShelfBcList = () => {
        let tmp = []
        
        currentTable.items.map((el, index) => {
          tmp.push({
            code: `Table_${el.status}`,
            title: `${listTables[0].name} ${el.status}`
          })
        })
        console.log("ret", tmp)
        return tmp
    }
  
    return(
      <div>
        <MenuItem onClick={DialoghandleClickOpen}>Печать ШК</MenuItem>
        <Dialog
          open={open}
          onClose={DialoghandleClose}
          maxWidth={false}
          PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
          >
            <div
              style={{height:'500px', width:'400px'}}
            >
              <TablesAllBarCode list={getShelfBcList() || []} onClose={DialoghandleClose}/>
            </div>
        </Dialog>
      </div>
    )
  }

  function TablesAllBarCode({ list, onClose }) {
    /** @type {[any, Function]} */
    const [data, setData] = useState([]);
    /** @type {[any, Function]} */
    const [printTrigger, setPrintTrigger] = useState(null);
    const [loadingPrint, setLoadingPrint] = useState(false);
    const printContainerRef = useRef(null);

    const preventDoubleClick = usePreventDoubleClick();

    // Формируем массив кодов из list
    useEffect(() => {
      console.log("list", list)
        const res = [];
        for (const el of list) {
            const tmp = el.title.split(' ');
            let code = tmp[tmp.length - 1].replace('_', '-');
            res.push(code);
        }
        setData(res);
    }, [list]);

    const startPrint = useReactToPrint({
        contentRef: printContainerRef,
        pageStyle: `
            @page { 
                size: 58mm 40mm; 
                margin: 0 !important; 
                padding: 0 !important;
                marks: none;
            }
            body { 
                margin: 0 !important; 
                padding: 0 !important;
                -webkit-print-color-adjust: exact; 
                print-color-adjust: exact;
                background: white;
            }
            html, body { 
                height: auto !important;
                overflow: visible !important;
            }
            * {
                box-sizing: border-box;
            }
            .barcode-print-page {
                width: 58mm;
                height: 40mm;
                page-break-after: always;
                break-after: page;
                overflow: hidden;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0;
                padding: 0;
            }
            .barcode-print-page:last-child {
                page-break-after: auto;
                break-after: auto;
            }
            img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        `,
        documentTitle: 'Компонент',
        onAfterPrint: () => {
            setLoadingPrint(false);
            setPrintTrigger(null);
        }
    });

    const handlePrint = () => {
        if (!data.length) return;
        setLoadingPrint(true);
        // Передаём в триггер все коды — каждая страница будет отдельным баркодом
        setPrintTrigger({ items: data });
    };

    useEffect(() => {
        if (!printTrigger) return;

        const runPrint = async () => {
            // Даём React время отрендерить скрытый контейнер
            await new Promise(resolve => setTimeout(resolve, 100));
            startPrint();
        };

        runPrint();
    }, [printTrigger, startPrint]);

    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div style={{ height: '92%', display: 'flex', flexDirection: 'row' }}>
                <Scrollbars
                    style={{ width: '100%', height: '100%'}} 
                >
                    <div ref={printContainerRef} 
                        style={{
                            display: 'flex', 
                            flexDirection: 'column', 
                            alignItems: 'center', 
                            width: "100%", 
                            gap: printTrigger? "0px": "10px"
                      }}>
                        {data.map((item) => (
                            <Card sx={{ borderRadius: 3, width: "58mm", height: "40mm" }}>
                                <CardContent sx={{ marginTop: "3mm", display:'flex', width: "100%", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                                    <Typography sx={{ marginLeft: "2mm", fontWeight: 'bold', lineHeight: "10mm", fontSize: "12mm" }}>{item}</Typography>
                                        <Box sx={{ marginTop: "3mm" }}>
                                            <Barcode format='CODE128' value={item} width={2.0} height={30} fontSize={0} textMargin={0} />
                                        </Box>
                                </CardContent>
                            </Card>
                        ))}
                    </div>
                </Scrollbars>
            </div>
            <Box
                sx={{
                    display: "flex",
                    gap: 2,
                    height: "8%",
                    width: "100%",
                    justifyContent: 'space-between',
                    alignItems: 'flex-end'
                }}
            >
            
                <CancelButton action={onClose} text={"ЗАКРЫТЬ"}/>
                <OKButton action={handlePrint} text={"ПЕЧАТЬ"} />
                
            </Box>
        </div>
    );
}
  

  export const DropDownNestedTableMenu = ({currentStatus, setListTables, listTables, name, color, colorcircule, listItems, setEmitFlag, currentTab}) => {
  
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    
  
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const removeTable = () => {
      let re = new RegExp(currentStatus + "_[0-9]", "gm");
      if ((Object.keys(listItems).findIndex(item => (re.test(item)))) === -1){
        setEmitFlag(true);
        setListTables([...listTables.filter(item => (item.status !== ''+currentStatus))])
      }
      handleClose()
    }
  
    const handleClose = () => {
      setAnchorEl(null);
    };

    //copyy
    return (
      <div
      style={{display:'block',
        clear: 'both',
        float: 'right',
        height: '34px'}}
      >
        <IconButton
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
              size='small'
              sx={{
                
              }}
          >
              <MoreVertIcon/>
          </IconButton>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          <EditNestedTableDialog
            handleClose={handleClose}
            currentStatus={currentStatus}
            setListTables={setListTables}
            listItems={listItems}
            listTables={listTables}
            oldname={name}
            oldcolor={color}
            oldcolorcircule={colorcircule}
            setEmitFlag={setEmitFlag}
          />
          <PrintBarcode handleClose={handleClose} listTables={listTables} currentStatus={currentStatus} currentTab={currentTab}/>
          <MenuItem onClick={removeTable}>Удалить</MenuItem>
        </Menu>
      </div>
    );
  }

  export const NestedUpContainer = ({
    ds, 
    color, 
    colorcircule, 
    items = [], 
    showItems, 
    status, 
    name, 
    filtername, 
    isDragging, 
    handleDragging, 
    handleUpdateList, 
    handleUpdateTicket, 
    toggleDrawer, 
    setInsertelement, 
    setListTables, 
    listTables, 
    setEmitFlag, 
    setListItems,
    dragItemRef,
    selectedColumnRef,
    cloneItemRef,
    currentTab
  }) => {
    const setNestedListTables = (index, list) => {
      var array = [...listTables];
      array[index].items = list;
      setListTables(array);
    }
    let mainindex = listTables.findIndex(item => item.status === status);

    const Container = ds.items[0]?.formatter;

    return (
      <div
      key={name+status}
      style = {{
        minWidth: '250px',
        position: 'relative',
        display: 'inline-block', 
        verticalAlign:'top',
        marginRight:'40px'
      }}
      >
          <div style={{ height:'70px', backgroundColor:color, marginBottom:'2px', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight:'40px', borderTopLeftRadius: '7px', borderTopRightRadius: '7px'}}>
              <div style={{ display:'flex', margin: '0px auto', alignItems: 'center', justifyContent: 'center', }}>
                  <Typography variant="subtitle2" noWrap sx={{position: 'relative', marginLeft:'40px', maxWidth:'200px', fontSize: '18px'}}>{name}</Typography>
                </div>
                {ds.admin ? <DropDownNestedTableMenu
                  currentStatus={status}
                  setListTables={setListTables}
                  listTables={listTables}
                  name={name}
                  color={color}
                  colorcircule={colorcircule}
                  listItems={showItems}
                  setEmitFlag={setEmitFlag}
                  currentTab={currentTab}
                /> : 
                <div
                  style={{display:'block',
                  clear: 'both',
                  float: 'right', 
                  height: '34px',
                  width: '34px'}}
                  />}
                </div>
          <Scrollbars
            autoHeight autoHeightMax={'75vh'}
          >
            {listTables[mainindex]?.items.map((container, index) => {
              return (
              <div key={`${mainindex + 1}-${index + 1}+nested_up`} style={{verticalAlign:'top', marginBottom:'2px',}}>
                <div style = {{
                  minWidth: '250px',
                  position: 'relative',
                  display: 'table', 
                }}>
                  <div
                  style={{
                    width:'5px',
                    backgroundColor:color,
                    display: 'table-cell', 
                  }}
                  />
                  <Container
                      ds={ds.items[0]}
                      color={container.color}
                      colorcircule={container.colorcircule}
                      items={items}
                      showItems={showItems}
                      handleUpdateTicket={handleUpdateTicket}
                      name={`${Array.from(name)[0]}-${mainindex + 1}-${index + 1}`}
                      status={`${container.status}`}
                      key={`${mainindex + 1}-${index + 1}`}
                      filtername={filtername}
                      isDragging={isDragging}
                      handleDragging={handleDragging}
                      handleUpdateList={handleUpdateList}
                      toggleDrawer={toggleDrawer}
                      setInsertelement={setInsertelement}
                      setListTables={(list) => setNestedListTables(+status - 1, list)}
                      listTables={listTables[mainindex]?.items}
                      setEmitFlag={setEmitFlag}
                      setListItems={setListItems}
                      dragItemRef={dragItemRef}
                      selectedColumnRef={selectedColumnRef}
                      cloneItemRef={cloneItemRef}
                  />
                  <div
                  style={{
                    width:'5px',
                    backgroundColor:color,
                    display: 'table-cell', 
                  }}
                  />
                </div>
                <div
                style={{
                  height:'5px',
                  backgroundColor:color,
                }}
                />
              </div>
              )
            })}
          </Scrollbars>
    </div>
    )
  }

  export const ASNestedUpContainer = ({
    ds, 
    color, 
    colorcircule, 
    items = [], 
    showItems, 
    status, 
    name, 
    filtername, 
    isDragging, 
    handleDragging, 
    handleUpdateList, 
    handleUpdateTicket, 
    toggleDrawer, 
    setInsertelement, 
    setListTables, 
    listTables, 
    setEmitFlag, 
    setListItems,
    dragItemRef,
    selectedColumnRef,
    cloneItemRef,
    currentTab
  }) => {
    const setNestedListTables = (index, list) => {
      var array = [...listTables];
      array[index].items = list;
      setListTables(array);
    }
    let mainindex = listTables.findIndex(item => item.status === status);

    const Container = ds.items[0]?.formatter;

    return (
      <div
        key={name+status}
        style = {{
          width: '280px',
          position: 'relative',
          display: 'inline-block', 
          verticalAlign:'top',
          marginRight:'20px',
          height: "82%"
        }}
      >
          <div
              style = {{
                  width: '100%',
                  height:"8px",
                  position: 'absolute',
                  backgroundColor: color,
                  borderTopRightRadius:'10px',
                  borderTopLeftRadius:'10px',
                  display: 'inline-block', 
                  verticalAlign:'top',
                  
              }}
            />
          <div 
            style={{ 
              height:'60px', 
              backgroundColor: 'rgba(255, 255, 255, 0.4)', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',  
              borderTopLeftRadius: '10px', 
              borderTopRightRadius: '10px',
            }}
          >
              <div style={{ display:'flex', margin: '0px auto', alignItems: 'center', justifyContent: 'center', }}>
                <Typography variant="subtitle2" noWrap sx={{position: 'relative', marginLeft:'40px', maxWidth:'230px', fontSize: '18px', color: "#8c8c8c"}}>{name.toUpperCase()}</Typography>
              </div>
              {ds.admin ? 
                <DropDownNestedTableMenu
                  currentStatus={status}
                  setListTables={setListTables}
                  listTables={listTables}
                  name={name}
                  color={color}
                  colorcircule={colorcircule}
                  listItems={showItems}
                  setEmitFlag={setEmitFlag}
                  currentTab={currentTab}
                />
                : 
                <div
                  style={{display:'block',
                  clear: 'both',
                  float: 'right', 
                  height: '34px',
                  width: '34px'}}
                />
              }
          </div>
          <div
            style={{
              borderBottomRightRadius:'10px',
              borderBottomLeftRadius:'10px',
              height: "100%",
              width: "100%",
              // backgroundColor: "red"
            }}
          >
            <Scrollbars
              // autoHeight
              // autoHeightMin={"410px"}
              // autoHeightMax={"410px"}
              style={{
                height: "100%",
              }}  
            >
              {listTables[mainindex]?.items.map((container, index) => {
                return (
                  <div key={`${mainindex + 1}-${index + 1}+nested_up`} style={{verticalAlign:'top'}}>
                    <div 
                      style = {{
                        width: '100%',
                        position: 'relative',
                        display: 'table', 
                        backgroundColor: 'rgba(255, 255, 255, 0.4)', 
                      }}
                    >
                      <div style={{width: "100%", display: "flex", flexDirection: "row", justifyItems: "center"}}>
                        <Container
                          ds={ds.items[0]}
                          color={container.color}
                          colorcircule={container.colorcircule}
                          items={items}
                          showItems={showItems}
                          handleUpdateTicket={handleUpdateTicket}
                          // name={`${Array.from(name)[0]}-${mainindex + 1}-${index + 1}`}
                          name={`${container.status.replaceAll('_', '-')}`}
                          status={`${container.status}`}
                          // key={`${mainindex + 1}-${index + 1}`}
                          key={`${container.status}`}
                          filtername={filtername}
                          isDragging={isDragging}
                          handleDragging={handleDragging}
                          handleUpdateList={handleUpdateList}
                          toggleDrawer={toggleDrawer}
                          setInsertelement={setInsertelement}
                          setListTables={(list) => setNestedListTables(+status - 1, list)}
                          listTables={listTables[mainindex]?.items}
                          setEmitFlag={setEmitFlag}
                          setListItems={setListItems}
                          dragItemRef={dragItemRef}
                          selectedColumnRef={selectedColumnRef}
                          cloneItemRef={cloneItemRef}
                        />
                      </div>
                  </div>
                </div>
                )
              })}
            </Scrollbars>
          </div>
          
    </div>
    )
  }

  export const ASContainerCards = ({
    ds, 
    color, 
    colorcircule, 
    showItems, 
    items = [], 
    showStatus = false,
    status, 
    name, 
    filtername, 
    isDragging, 
    handleDragging, 
    handleUpdateList, 
    handleUpdateTicket, 
    toggleDrawer, 
    setInsertelement, 
    setListTables, 
    listTables, 
    setEmitFlag,  
    setListItems,
    dragItemRef,
    selectedColumnRef,
    cloneItemRef
  }) => {

    const { rules } = useSelector(
        loginSelector
    );

    // Создание ссылки на контейнер. Она нужна для определения таргетированной воронки при перетягивании тикета
    const columnRef = useRef(null);
    // Обработчик ивента фиксации тикета в воронке
    const handleDrop = (e) => {
        e.preventDefault(); // Прерываем поток событий
        handleUpdateList(e.dataTransfer.getData('text'), status); // Обновляем массив тикетов в соответствии с данными в dataTransfer 
        handleDragging(false); // Снятие флага перетаскивания
        cloneItemRef.current.remove();  // Удаление теневого клона тикета

        // Восстановление стиля реального тикета для корректного отображения
        dragItemRef.current.style.visibility = 'visible'; dragItemRef.current.style.height = ''; dragItemRef.current.style.margin = '10px'; dragItemRef.current.style.padding = ''; dragItemRef.current.style.overflow = '';
        dragItemRef.current.style.opacity = '1'; dragItemRef.current.style.boxShadow = '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)';
    }
    
    // Обработчик перетаскивания тикета над информационной частью столбца
    const handleDragHeaderOver = (e) => {
      if (isDragging){  // Проверка состояния перетаскивания
      e.preventDefault()  // Прерываем поток событий
      if (window.getComputedStyle(cloneItemRef.current).display === "none") cloneItemRef.current.style.display = ''; // Проверяем отображение теневого клона тикета, если он невидим, возвращаем его
          dragItemRef.current.style.opacity = '1';
          selectedColumnRef.current?.querySelector(`.zeroTicket`).prepend(cloneItemRef.current); // Размещаем слона перед 0 тикетом. Он не содержит данных. Служит якорем для фиксации на 1ую позицию без использования фактических тикетов
      }
        setInsertelement({position:null, idanchor:-1}) // Обнуляем позицию для вставки. Если она будет пуста при фиксации, тикет будет помещён на 0 позицию в массиве
    }
    
    // Обработчик перетаскивания тикета над столбцом. Тут происходит обновление ссылки на столбец, в том случае если мы перетянули тикет из одного столбца в другой
    const handleDragOver = (e) => { e.preventDefault(); if (selectedColumnRef.current?.id !== status) {selectedColumnRef.current = columnRef.current;}
    }

    //console.log("SS", showStatus)

    //aaaa

      return (
        <div
          key={name+status}
          style = {{
            minWidth: '280px',
            height:'86%',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            verticalAlign:'top', 
            marginLeft: ds.admin && (rules.includes("main.change_columns") || rules.includes("admin"))? "0px": "20px",
            marginBottom: "10px",
          }}
        >
        <div
          style = {{
              width: '250px',
              minWidth: '250px',
              position: 'relative',
              backgroundColor: 'rgba(255, 255, 255, 0.4)',
              borderRadius:'10px',
              display: 'inline-block',
              flexDirection: 'column',
              maxHeight: '75vh',
              height: 'auto'
          }}
          id={status}
          ref={columnRef}
          className={`layout-cards ${isDragging ? 'layout-dragging' : ''} card_container${status}`}
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          >
          <div
              onDragOver={handleDragHeaderOver}
              style = {{
                  width: '250px',
                  minWidth: '250px',
                  position: 'relative',
                  // backgroundColor: color,
                  backgroundColor: "white",
                  borderTopRightRadius:'10px',
                  borderTopLeftRadius:'10px',
                  borderBottomRightRadius:Object.keys(showItems[status] || {}).length >0? '0px': '10px',
                  borderBottomLeftRadius:Object.keys(showItems[status] || {}).length >0? '0px': '10px',
                  display: 'inline-block', 
                  verticalAlign:'top',
                  height: Object.keys(showItems[status] || {}).length >0? "35px": "45px"
                  
              }}
              >
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', minHeight:'20px',marginTop:'10px', marginBottom:'10px'}}>
                <div style={{ display:'flex', margin: '0px auto', marginTop: Object.keys(showItems[status] || {}).length >0? "-10px": "-5px",  alignItems: 'center', justifyContent: 'space-between'}}>
                  <Typography variant="subtitle2" noWrap sx={{position: 'relative', marginLeft:'40px', maxWidth:'180px', fontSize: '18px', color: "#8c8c8c"}}>{name}</Typography>
                </div>
                {ds.admin && !ds.nested && (rules.includes("main.change_columns") || rules.includes("admin"))? 
                  <DropDowntableMenu
                    currentStatus={status}
                    setListTables={setListTables}
                    listTables={listTables}
                    name={name}
                    color={color}
                    colorcircule={colorcircule}
                    listItems={items}
                    setEmitFlag={setEmitFlag}
                    showItems={showItems}
                    showStatus={showStatus}
                  /> : 
                  <div
                    style={{display:'block',
                      clear: 'both',
                      float: 'right', 
                      height: '34px',
                      width: '34px'
                    }}
                  />
                }
              </div>
          </div>
          <Scrollbars
            className='mainContainer'
            autoHeight autoHeightMax={'62vh'}
            
          >
            <div className = {`zeroTicket`}/>
            <CardsWithFilter
              ds={ds.items[0]}
              items={items}
              filter={filtername}
              isDragging={isDragging}
              handleDragging={handleDragging}
              toggleDrawer={toggleDrawer}
              showItems={showItems[status]}
              setInsertelement={setInsertelement}
              setEmitFlag={setEmitFlag}
              setListItems={setListItems}
              handleUpdateTicket={handleUpdateTicket}
              dragItemRef={dragItemRef}
              selectedColumnRef={selectedColumnRef}
              cloneItemRef={cloneItemRef}
            />
          </Scrollbars>
        </div>
        {ds.admin && !ds.nested && (rules.includes("main.change_columns") || rules.includes("admin"))?
          <AddTableDialog
            parentStatus={status}
            setListTables={setListTables}
            listTables={listTables}
            setEmitFlag={setEmitFlag}
          /> :
          <></>
        }
      </div>
    )
  }